import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import moment from 'moment'

const BlockRecord = ({ onBlock, onContinue, onFinish }) => {
  const [count, setCount] = useState(120)
  const [isBlock, setBlock] = useState(false)

  const handleClose = () => {
    onContinue()
  }

  useEffect(() => {
    const decrement = () => {
      setCount(prevCount => prevCount - 1)
    }

    const intervalId = setInterval(decrement, 1000)

    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    if (count <= 0) {
      setBlock(true)
    }
  }, [count])
  if (isBlock) {
    return (<Modal
      visible={true}
      maskClosable={false}
      destroyOnClose={false}
      closable={false}
      footer={[
        <button className={'btn btn-secondary dart-btn'}
                onClick={e => onFinish(e, true, false)}
        >Okay</button>]}>
      <h3 className={'mt-3'}>Session timed out</h3>
      <p>Your session has ended due to inactivity. Your changes have been
        saved.</p>
    </Modal>)
  }
  const timer = moment.utc(
    count * 1000).format('mm:ss')
  return (
    <Modal
      visible={true}
      maskClosable={false}
      destroyOnClose={true}
      closable={false}
      footer={[
        <button className={'btn btn-secondary dart-btn'}
                onClick={handleClose}
        >Extend session</button>,
        <button className={'btn btn-outline-secondary dart-btn-outline'}
                onClick={() => onBlock({ preventDefault: () => null })}
        >End session now</button>]}>
      <h3 className={'mt-3'}>Are you still there?</h3>
      <p>It looks like you have been inactive for a while. Your changes have all
        been auto-saved. If you are still working, you may extend your session
        by clicking Extend session below; otherwise in {timer} your editing session
        will end.</p>
    </Modal>
  )
}

export default BlockRecord
